export class VendorAccount {
  vendorAccountId: number;
  acronym: string;
  name: string;
  shortName: string;
  description: string;
  storageName: string;
  isActive: boolean;
  displayOrder: number;
  createdOn: Date;
  isDataAvalabilityFilter: boolean;
  isFinancialItemFilter: boolean;
  isBalanceSheetItem: boolean;
}
